export default __webpack_public_path__ + "static/media/info_start.min.e014b974.png";